// Mapowanie miast z citiesCoordinates.js → województwa

export type Voivodeship =
  | 'dolnośląskie'
  | 'kujawsko-pomorskie'
  | 'lubelskie'
  | 'lubuskie'
  | 'łódzkie'
  | 'małopolskie'
  | 'mazowieckie'
  | 'opolskie'
  | 'podkarpackie'
  | 'podlaskie'
  | 'pomorskie'
  | 'śląskie'
  | 'świętokrzyskie'
  | 'warmińsko-mazurskie'
  | 'wielkopolskie'
  | 'zachodniopomorskie';

export const cityVoivodeships: Record<string, Voivodeship> = {
  'Warszawa': 'mazowieckie',
  'Kraków': 'małopolskie',
  'Gdańsk': 'pomorskie',
  'Poznań': 'wielkopolskie',
  'Wrocław': 'dolnośląskie',
  'Łódź': 'łódzkie',
  'Katowice': 'śląskie',
  'Lublin': 'lubelskie',
  'Białystok': 'podlaskie',
  'Szczecin': 'zachodniopomorskie',
  'Gdynia': 'pomorskie',
  'Rzeszów': 'podkarpackie',
  'Bydgoszcz': 'kujawsko-pomorskie',
  'Olsztyn': 'warmińsko-mazurskie',
  'Zielona Góra': 'lubuskie',
  'Toruń': 'kujawsko-pomorskie',
  'Opole': 'opolskie',
  'Kielce': 'świętokrzyskie',
  'Tarnów': 'małopolskie',
  'Gorzów Wielkopolski': 'lubuskie',
  'Elbląg': 'warmińsko-mazurskie',
  'Płock': 'mazowieckie',
  'Wałbrzych': 'dolnośląskie',
  'Włocławek': 'kujawsko-pomorskie',
  'Tychy': 'śląskie',
  'Dąbrowa Górnicza': 'śląskie',
  'Radom': 'mazowieckie',
  'Sosnowiec': 'śląskie',
  'Ruda Śląska': 'śląskie',
  'Rybnik': 'śląskie',
  'Gliwice': 'śląskie',
  'Częstochowa': 'śląskie',
  'Słupsk': 'pomorskie',
  'Jaworzno': 'śląskie',
  'Jastrzębie-Zdrój': 'śląskie',
  'Jelenia Góra': 'dolnośląskie',
  'Nowy Sącz': 'małopolskie',
  'Konin': 'wielkopolskie',
  'Piotrków Trybunalski': 'łódzkie',
  'Lubin': 'dolnośląskie',
  'Inowrocław': 'kujawsko-pomorskie',
  'Ostrowiec Świętokrzyski': 'świętokrzyskie',
  'Stargard': 'zachodniopomorskie',
  'Siedlce': 'mazowieckie',
  'Mysłowice': 'śląskie',
  'Pabianice': 'łódzkie',
  'Gniezno': 'wielkopolskie',
  'Siemianowice Śląskie': 'śląskie',
  'Oława': 'dolnośląskie',
  'Głogów': 'dolnośląskie',
  'Piekary Śląskie': 'śląskie',
  'Zawiercie': 'śląskie',
  'Legnica': 'dolnośląskie',
  'Tarnobrzeg': 'podkarpackie',
  'Racibórz': 'śląskie',
  'Świętochłowice': 'śląskie',
  'Kędzierzyn-Koźle': 'opolskie',
  'Starachowice': 'świętokrzyskie',
  'Zgierz': 'łódzkie',
  'Bielsko-Biała': 'śląskie',
  'Przemyśl': 'podkarpackie',
  'Wodzisław Śląski': 'śląskie',
  'Skierniewice': 'łódzkie',
  'Krosno': 'podkarpackie',
};

export const VOIVODESHIPS: Voivodeship[] = [
  'dolnośląskie',
  'kujawsko-pomorskie',
  'lubelskie',
  'lubuskie',
  'łódzkie',
  'małopolskie',
  'mazowieckie',
  'opolskie',
  'podkarpackie',
  'podlaskie',
  'pomorskie',
  'śląskie',
  'świętokrzyskie',
  'warmińsko-mazurskie',
  'wielkopolskie',
  'zachodniopomorskie',
];

const citiesByLength = Object.keys(cityVoivodeships).sort((a, b) => b.length - a.length);

export const formatVoivodeshipLabel = (voivodeship: Voivodeship): string =>
  voivodeship.charAt(0).toUpperCase() + voivodeship.slice(1);

/** Województwo dla pola city wydarzenia (dokładne lub częściowe dopasowanie miasta). */
export const getVoivodeshipForEventCity = (eventCity: string): Voivodeship | null => {
  if (!eventCity) return null;

  const trimmed = eventCity.trim();
  if (cityVoivodeships[trimmed]) return cityVoivodeships[trimmed];

  const lower = trimmed.toLowerCase();
  for (const [city, voivodeship] of Object.entries(cityVoivodeships)) {
    if (city.toLowerCase() === lower) return voivodeship;
  }

  for (const city of citiesByLength) {
    if (lower.includes(city.toLowerCase())) return cityVoivodeships[city];
  }

  return null;
};

export const getCitiesInVoivodeship = (voivodeship: Voivodeship): string[] =>
  Object.entries(cityVoivodeships)
    .filter(([, v]) => v === voivodeship)
    .map(([city]) => city);

/** Województwo z zapisanego pola lub fallback z miasta. */
export const getVoivodeshipForEvent = (event: {
  voivodeship?: string | null;
  city?: string;
}): Voivodeship | null => {
  const stored = (event.voivodeship || '').trim().toLowerCase();
  if (stored && (VOIVODESHIPS as readonly string[]).includes(stored)) {
    return stored as Voivodeship;
  }
  return getVoivodeshipForEventCity(event.city || '');
};

/** Województwo dla wybranej miejscowości z listy 64 miast. */
export const getVoivodeshipForCity = (city: string): Voivodeship | null => {
  if (!city) return null;
  if (cityVoivodeships[city]) return cityVoivodeships[city];
  return getVoivodeshipForEventCity(city);
};
